module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
var state = [{name:'Normal', id: 'normal'}, {name:'Read-Only', id:'readonly'}, {name:'Disabled', id:'disabled'}];
var start = [{name:'Default', id: 'default'}, {name:'Last shown', id:'last'}];

    ; __append("\r\n<div class=\"row prop-detail\">\r\n    <div class=\"row\">\r\n        <div class=\"col-md-12 subsection nopadding-r\">\r\n            <label class=\"prop-sublabel label-60\">State</label> \r\n            <div style=\"display: inline-flex;\">\r\n                <select name=\"viewingState\" id=\"viewingState\">\r\n                    ")
    ;  for (var i = 0; i < state.length; i++) { 
    ; __append("\r\n                        <option value=\"")
    ; __append(escapeFn(state[i].id))
    ; __append("\">")
    ; __append(escapeFn(state[i].name))
    ; __append("</option>\r\n                    ")
    ;  }; 
    ; __append("\r\n                </select>\r\n                <div class=\"nopadding button-opener\">\r\n                    <button id=\"browseState\" class=\"btn btn-default hvr-glow button-selector\">...</button>\r\n                </div>\r\n            </div>\r\n        </div> \r\n    </div>\r\n    <div class=\"row\">\r\n        <div class=\"col-md-12 subsection nopadding-r\">\r\n            <label class=\"prop-sublabel label-60\">Start Page</label> \r\n            <div style=\"display: inline-flex;\">\r\n                <select name=\"startPage\" id=\"startPage\" >\r\n                    ")
    ;  for (var i = 0; i < start.length; i++) { 
    ; __append("\r\n                        <option value=\"")
    ; __append(escapeFn(start[i].id))
    ; __append("\">")
    ; __append(escapeFn(start[i].name))
    ; __append("</option>\r\n                    ")
    ;  }; 
    ; __append("\r\n                </select>\r\n                <div class=\"nopadding button-opener\">\r\n                    <button id=\"browseStartPage\" class=\"btn btn-default hvr-glow button-selector\">...</button>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>")
  }
  return __output;

}